import { createSelector } from '@reduxjs/toolkit';
import { IContactPreferenceRoot } from './models';

export const selectContactPreference = (state: IContactPreferenceRoot) => state.contactPreference;

export const selectContactPreferenceUserFetchDisabled = createSelector(
  selectContactPreference,
  ({ userState }) => userState === 'loading' || userState === 'saving'
);
export const selectContactPreferenceUserSaveDisabled = createSelector(
  selectContactPreference,
  ({ userState }) => userState === 'loading' || userState === 'saving' || userState === 'disabled'
);
export const selectContactPreferenceUser = createSelector(
  selectContactPreference,
  ({ userState, userLoadTime, userProductsOptIn: productsOptIn }) => ({
    disabled: userState === 'disabled',
    readonly: userState === 'loading' || userState === 'saving' || userState === 'disabled',
    activity: userState === 'loading' || userState === 'saving' ? userState : undefined,
    shouldFetch: userState === 'saved' || Date.now() - userLoadTime > 30000,
    productsOptIn
  })
);

export const selectContactPreferenceAdminFetchDisabled = createSelector(
  selectContactPreference,
  ({ adminState }) => adminState === 'loading' || adminState === 'saving'
);
export const selectContactPreferenceAdminSaveDisabled = createSelector(
  selectContactPreference,
  ({ adminState }) => adminState === 'loading' || adminState === 'saving'
);
export const selectContactPreferenceAdminIsInvalid = createSelector(
  selectContactPreference,
  ({ adminPartnersPhoneNumberError, adminPartnersEmailError }) =>
    !!adminPartnersPhoneNumberError || !!adminPartnersEmailError
);
export const selectContactPreferenceAdmin = createSelector(
  selectContactPreference,
  ({
    adminState,
    adminLoadTime,
    adminOffersOptIn: offersOptIn,
    adminPartnersOptIn: partnersOptIn,
    adminPartnersEmail: partnersEmail,
    adminPartnersEmailError: partnersEmailError,
    adminPartnersCountryCode: partnersCountryCode,
    adminPartnersPhoneNumber: partnersPhoneNumber,
    adminPartnersPhoneNumberError: partnersPhoneNumberError
  }) => ({
    readonly: adminState === 'loading' || adminState === 'saving',
    activity: adminState === 'loading' || adminState === 'saving' ? adminState : undefined,
    shouldFetch: adminState === 'saved' || Date.now() - adminLoadTime > 30000,
    offersOptIn,
    partnersOptIn,
    partnersEmail,
    partnersEmailError,
    partnersCountryCode,
    partnersPhoneNumber,
    partnersPhoneNumberError
  })
);
